<template>
  <validation-observer ref="formCompany">
    <b-form @submit.prevent>
      <b-row>
        <!-- username -->
        <b-col cols="12" sm="10">
          <validation-provider
            rules="required"
            v-slot="{ errors }"
            name="Customer Source"
            vid="Customer Source"
          >
            <b-form-group label="Customer Source*" label-for="h-First">
              <b-form-select
                v-model="company.profile.source"
                :options="sourceDDL"
              />
              <small v-if="errors.length" class="text-danger">{{
                errors[0]
              }}</small>
            </b-form-group>
          </validation-provider>
        </b-col>
        <b-col cols="12" sm="2" class="d-flex align-items-center">
          <b-button
            variant="primary"
            class="w-100"
            @click="showModal('SOURCE')"
          >
            Add Source
          </b-button>
        </b-col>
       
        <b-col cols="12">
          <b-form-group label="Company Name*" label-for="h-company">
            <validation-provider
              rules="required"
              #default="{ errors }"
              name="Company Name"
              vid="Company Name"
            >
              <b-form-input
                id="h-full"
                placeholder="Company Name"
                v-model="company.otherName"
              />
              <small v-if="errors.length" class="text-danger">{{
                errors[0]
              }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>

        <b-col cols="12">
          <validation-provider
           
            #default="{ errors }"
            name="Sales Person"
            rules="required"
            vid="Sales Person"
          >
            <b-form-group label="Sales Person*" label-for="h-First">
              <b-form-select
                v-model="company.salesPersonId"
                :options="salesPersonDDL"
              />
              <small v-if="errors.length" class="text-danger">{{ errors[0] }}</small>
            </b-form-group>
          </validation-provider>
        </b-col>



        <b-col cols="12">
          <b-button
            v-on:click="isCollapseComp = !isCollapseComp"
            variant="primary"
          >
            {{ this.isCollapseComp ? "See More" : "See Less" }}
          </b-button>
        </b-col>


        <b-col v-if="!isCollapseComp" cols="12">

        <!-- email -->
        <b-col cols="12">
          <validation-provider
            rules="email_regex"
            v-slot="{ errors }"
            name="email"
            vid="email"
          >
            <b-form-group label="Email" label-for="d-email">
              <b-form-input
                id="d-email"
                type="email"
                placeholder="Enter your email (e.g., example@domain.com)"
                v-model="company.email"
              />
              <small v-if="errors.length" class="text-danger">{{
                errors[0]
              }}</small>
            </b-form-group>
          </validation-provider>
        </b-col>

        
        
        <b-col cols="12">
            <b-form-group label="Address" label-for="h-Address">
              <b-form-input
                id="h-Address"
                placeholder="Address"
                v-model="company.addressLine1"
              />
            </b-form-group>
        </b-col>

        <b-col cols="12">
            <b-form-group label="Street Name" label-for="h-Street">
              <b-form-input
                id="h-Street"
                placeholder="Street Name"
                v-model="company.addressLine2"
              />
            </b-form-group>
        </b-col>

        <b-col cols="10">
            <b-form-group label="City" label-for="h-City">
              <b-form-select v-model="company.profile.city" :options="cityDDL" />
            </b-form-group>
        </b-col>
        <b-col cols="12" sm="2" class="d-flex align-items-center">
          <b-button variant="primary" class="w-100" @click="showModal('CITY')">
            Add City
          </b-button>
        </b-col>
        <b-col cols="12">
            <b-form-group label="Company Tel" label-for="h-tel">
              <b-form-input id="h-tel" placeholder="Company Tel" type="number"  onkeydown="javascript: return ['Backspace','Delete','ArrowLeft','ArrowRight'].includes(event.code) ? true : !isNaN(Number(event.key)) && event.code!=='Space'" v-model="company.tel" />
            </b-form-group>
        </b-col>

         <b-col cols="12">
            <b-form-group label="Category" label-for="h-specialInstructions">
              <b-form-input
                id="h-specialInstructions"
                placeholder="Category"
                v-model="company.fieldInstruction"
              />
            </b-form-group>
        </b-col>

        <b-col cols="12">
          <b-form-group label="Website" label-for="h-Website">
            <b-form-input
              id="h-Website"
              placeholder="Website"
              v-model="company.website"
            />
          </b-form-group>
        </b-col>

        <b-col cols="12">
          <b-form-group label="VAT Number" label-for="h-Number">
            <b-form-input
              id="h-Number"
              placeholder="VAT Number"
              v-model="company.vatNumber"
            />
          </b-form-group>
        </b-col>
        <b-col cols="12">
            <b-form-group label="Company BRN" label-for="h-Number">
              <b-form-input
                id="h-Number"
                placeholder="Company BRN"
                v-model="company.brn"
              />
            </b-form-group>
        </b-col>
        <!-- products interested in  -->
        <b-col cols="10">
          <b-form-group label="Products Interested in" label-for="h-title">
            <v-select
              multiple
              placeholder="Add Products Interested in"
              label="itemTitle"
              v-model="company.profile.productsInterestedIn"
              :options="productInterestDDL"
            />
          </b-form-group>
        </b-col>
        <b-col cols="12" sm="2" class="d-flex align-items-center">
          <b-button
            variant="primary"
            class="w-100"
            @click="showModal('PRODUCTINTEREST')"
          >
            Add Product Interest
          </b-button>
        </b-col>
        <!-- Segment -->
        <b-col cols="12">
          <b-form-group label="Marketing Segment" label-for="h-title">
            <v-select
              multiple
              placeholder="Add Marketing Segments"
              label="itemTitle"
              v-model="company.profile.marketingSegments"
              :options="segmentOptions"
            />
          </b-form-group>
        </b-col>
      </b-col>
      </b-row>
      <CustomFieldsDetails
        v-if="!isCollapseComp"
        :AdditionalFields="company.additionalFields"
        :ModuleReference="'LeadClient'"
        @onchange="additionalFieldChanges"
      ></CustomFieldsDetails>
    </b-form>
    <b-modal :id="modalId" :title="modalTitle" hide-footer>
      <b-form @submit.prevent="addItem">
        <b-form-group label-for="input-new-item">
          <b-form-input
            id="input-new-item"
            v-model="newItem"
            required
            placeholder="Enter new item"
          ></b-form-input>
        </b-form-group>
        <b-button type="submit" variant="primary">Add</b-button>
      </b-form>

      <div class="p-1" style="max-height: 500px; overflow-y: auto;" >
        <b-table
          striped
          hover
          :items="modalOptions"
          responsive
          :fields="fields"
        >
          <template v-slot:cell(name)="data">
            {{
              modalType === "PRODUCTINTEREST"
                ? data.item.itemTitle
                : data.item.text
            }}
          </template>
          <template #cell(actions)="data">
            <b-button
              size="sm"
              variant="danger"
              @click="deleteItem(data.item.value)"
              >Delete</b-button
            >
          </template>
        </b-table>
      </div>
    </b-modal>
  </validation-observer>
</template>

<script>
import {
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BFormCheckbox,
  BForm,
  BButton,
  BFormText,
  BDropdownItem,
  BFormTextarea,
  BDropdown,
  BFormDatalist,
  BFormSelect,
  BModal,
  VBModal,
  BTable,
} from "bootstrap-vue";
import Ripple from "vue-ripple-directive";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { required, email } from "@validations";
import { mapGetters, mapActions } from "vuex";
import vSelect from "vue-select";
import flatPickr from "vue-flatpickr-component";
import { fnSortingDropdown } from "@/libs/customFn";
import CustomFieldsDetails from "@/views/component/CustomFieldsDetails.vue";
import { extend } from "vee-validate";

extend("email_regex", {
  validate: value =>
  /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(value),
  message: "Please enter a valid email address in the format example@domain.com",
});
export default {
  components: {
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BFormCheckbox,
    BForm,
    BFormText,
    BButton,
    BFormDatalist,
    BDropdownItem,
    BFormTextarea,
    BDropdown,
    ValidationProvider,
    ValidationObserver,
    BFormSelect,
    vSelect,
    flatPickr,
    BModal,
  VBModal,
  BTable,
  CustomFieldsDetails,
  },
  directives: {
    Ripple,
  },

  props: {
    company: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      fields: [{ key: "name", sortable: true }, { key: "actions" }],
      optionsSalesPerson: [],
      sourceOptions: [],
      productInterestOptions: [],
      isCollapseComp: true,
      cityOptions: [],
      modalId: "",
      modalTitle: "",
      modalType: "",
      newItem: "",
      currentOptions: [],
      socialMedias: [
        { text: "Other", value: 0 },
        { text: "Facebook", value: 1 },
        { text: "Instagram", value: 2 },
        { text: "Twitter", value: 3 },
        { text: "LinkedIn", value: 4 },
      ],
      selected: "Select Social Media",

      ////////
      required,
      email,
    };
  },
  computed: {
    ...mapGetters("salesPersonModule", {
      SalesPersonList: "salesperson",
      loading: "loading",
    }),
    ...mapGetters("customerModule", {
      details: "details",
      loading: "loading",
    }),
    ...mapGetters("segmentModule", {
      segments: "segments",
      loading: "loading",
    }),
    modalOptions() {
      if (this.modalType === "PRODUCTINTEREST") {
        return this.productInterestOptions;
      } else if (this.modalType === "SOURCE") {
        return this.sourceOptions;
      } else if (this.modalType === "CITY") {
        return this.cityOptions;
      }
      return []; // Return an empty array as fallback
    },
    sourceDDL() {
      return fnSortingDropdown(this.sourceOptions);
    },
    salesPersonDDL() {
      return fnSortingDropdown(this.optionsSalesPerson);
    },
    cityDDL() {
      return fnSortingDropdown(this.cityOptions);
    },
    jobTitleDDL() {
      return fnSortingDropdown(this.jobTitleOptions);
    },
    hobbiesDDL() {
      return fnSortingDropdown(this.hobbiesOptions);
    },
    productInterestDDL() {
      return fnSortingDropdown(this.productInterestOptions);
    },
    sourceCustomer() {
      return fnSortingDropdown(this.sourceOptions);
    },
    segmentOptions() {
      // Assuming this.segments is the array containing segment data
      return this.segments.map((segment) => {
        return {
          value: segment.segmentId,
          itemTitle: segment.name,
        };
      });
    },
  },
  resetForm(){
    this.$refs.formCompany.reset();
  },
  async mounted() {
    await this.getSalesPersonListAction().then(() => {
      this.SalesPersonList.map((v, i) =>
        this.optionsSalesPerson.push({
          value: v.id,
          text: `${v.firstName}` + " " + `${v.lastName}`,
        })
      );
    });
    await this.getSegmentsAction()
      .then((response) => {})
      .catch((response) => {
        console.log(response);
      });
    await this.loadAndRefreshDetails();
  },
  methods: {
    ...mapActions("salesPersonModule", ["getSalesPersonListAction"]),
    ...mapActions("customerModule", [
      "getProfileDetailsListAction",
      "addProfileDetailAction",
    ]),
    ...mapActions("segmentModule", [
      "getSegmentsAction",
      "removeSegmentAction",
      "addSegmentAction",
      "updateSegmentAction",
    ]),
    saveSocialMedia(value, text) {
      this.company.source = value;
      this.selected = text;
    },
    async submitForm() {
      this.company.companyName = this.company.otherName;
    let isValid = await this.$refs.formCompany.validate();
      this.$emit("onchange", this.company);
        return isValid;
    },
    async loadAndRefreshDetails() {
      this.$swal({
        title: "Loading...",
        text: "Please wait while the details are loading...",
        allowEscapeKey: false,
        allowOutsideClick: false,
        didOpen: () => {
          this.$swal.showLoading();
        },
      });

      const typeArrays = {
        SOURCE: this.sourceOptions,
        PRODUCTINTEREST: this.productInterestOptions,
        CITY: this.cityOptions,
      };

      await this.getProfileDetailsListAction().then((response) => {
        for (const [type, optionsArray] of Object.entries(typeArrays)) {
          const filteredData = this.details.filter(
            (item) => item.type === type
          ).sort((a, b) => a.name.localeCompare(b.name));
          optionsArray.splice(
            0,
            optionsArray.length,
            ...filteredData.map((item) => ({
              value: item.id,
              text: item.name,
              itemTitle: type === "PRODUCTINTEREST" ? item.name : undefined,
            }))
          );
        }
      });
      this.$swal.close();
    },
    showModal(type) {
      this.modalType = type;
      this.modalId = `modal-${type.toLowerCase()}`;
      this.modalTitle = `Add ${type === "HOBBIE" ? "HOBBY" : type}`;

      this.currentOptions = this[`${type.toLowerCase()}Options`];
      this.$nextTick(() => {
        this.$bvModal.show(this.modalId);
      });
    },
    
    addItem() {
      this.$swal({
        title: "Loading...",
        text: "Please wait while the item is being added...",
        allowEscapeKey: false,
        allowOutsideClick: false,
        didOpen: () => {
          this.$swal.showLoading();
        },
      });

      // Validate character limits for "JOBTITLE" and "SOURCE" types
      if (
        (this.modalType === "JOBTITLE" && this.newItem.length > 100) ||
        (this.modalType === "SOURCE" && this.newItem.length > 50)
      ) {
        // Show SweetAlert if character limit is exceeded
        this.$swal({
          title: "Error!",
          text:
            this.modalType === "JOBTITLE"
              ? "Job title should not exceed 100 characters."
              : "Source should not exceed 50 characters.",
          icon: "error",
          customClass: {
            confirmButton: "btn btn-primary",
          },
          buttonsStyling: false,
        });
        return;
      }

      const payload = {
        name: this.newItem,
        type: this.modalType,
      };

      this.addProfileDetailAction(payload)
        .then(() => {
          this.loadAndRefreshDetails();
          this.showSuccessAlert("Item added successfully!");
          this.newItem = "";
          this.$bvModal.hide(this.modalId);
        })
        .catch((error) => {
        // console.log(error);
        console.log("This is an error: ", error);
         // Extract error message from the API response
      let errorMsg = "Failed to add item.";
      if (error.response?.data?.message) {
        errorMsg = error.response.data.message; // This ensures we show the correct backend error
      }

      // Display the error message using SweetAlert
      this.$swal({
        title: "Error!",
        text: errorMsg,
        icon: "error",
        customClass: {
          confirmButton: "btn btn-primary",
        },
        buttonsStyling: false,
      });
    });
      this.newItem = "";
      this.$bvModal.hide(this.modalId);
    },

    deleteItem(value) {
      this.$swal({
        title: "Loading...",
        text: "Please wait while the item is being deleted...",
        allowEscapeKey: false,
        allowOutsideClick: false,
        didOpen: () => {
          this.$swal.showLoading();
        },
      });
      this.deleteCustomerProfileDetailAction(value)
        .then(() => {
          this.loadAndRefreshDetails();
          this.showSuccessAlert("Item deleted successfully!");
        })
        .catch((error) => {
          this.showErrorAlert("Failed to delete item: " + error.message);
          this.$swal.close();
        });
    },
    additionalFieldChanges(customFields) {
      this.company.additionalFields = customFields;
    },
  },
};
</script>
<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
@import "@core/scss/vue/libs/vue-flatpicker.scss";
</style>
